import * as React from "react";
import { compose } from "@grandvisionhq/utils";
/* empty css                */
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
const CmsWhitespace = ({ component }) => {
  const { size } = component.getParameters();
  if (!size) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: `whitespace whitespace--${size}`, "data-t": "cms-whitespace" });
};
const Whitespace = compose(withBreakpointVisibility, withAnchor)(CmsWhitespace);
export {
  CmsWhitespace,
  Whitespace as default
};
//# sourceMappingURL=Whitespace.js.map
